type PathParams = {
  restaurantId?: string;
  tableCode?: string;
  orderId?: string;
  orderItemId?: string;
  itemId?: string;
  menuId?: string;
  hours?: boolean;
};

export const makePath = (params: PathParams): string => {
  const { restaurantId, tableCode, orderId, orderItemId, itemId, menuId, hours } = params;

  const restaurantPath = `/locations/${restaurantId}${
    !tableCode || tableCode === 'Pickup Window' ? '' : `:${tableCode}`
  }`;
  const locationPath = menuId
    ? `${restaurantPath}/menus/${encodeURIComponent(menuId)}`
    : restaurantPath;
  // edit order item on checkout page
  if (orderId && orderItemId) {
    return `/orders/${orderId}/order-item/${orderItemId}`;
  }
  // edit order item on menu page
  if (orderItemId) {
    return `${locationPath}/order-item/${orderItemId}`;
  }
  // item details on menu page
  if (itemId) {
    return `${locationPath}/items/${itemId}`;
  }
  if (hours) return `${locationPath}/hours`;

  return locationPath;
};
